import React from 'react';
import { Field } from 'react-final-form';
import {
  StaticDatePickerProps as MuiDatePickerProps,
  StaticDatePicker as MuiDatePicker,
} from '@mui/x-date-pickers';

function DatePickerWrapper(props: MuiDatePickerProps<Date>) {
  const { onChange, value, ...rest } = props;

  return (
    <MuiDatePicker
      onChange={onChange}
      value={value}
      // Used to hide "Cancel" and "Ok" buttons
      slots={{ actionBar: () => null }}
      {...rest}
    />
  );
}

export interface StaticDatePickerProps
  extends Partial<Omit<MuiDatePickerProps<Date>, 'value' | 'onChange'>> {
  name: string;
}

export function StaticDatePicker(props: StaticDatePickerProps) {
  const { name, ...rest } = props;

  return (
    <Field
      name={name}
      render={({ input: { value, onChange } }) => (
        <DatePickerWrapper value={value} onChange={onChange} {...rest} />
      )}
    />
  );
}
